module.exports = "<div gw-pl-stepper-ctrl\r\n     display-value=\"displayValue()\"\r\n     have-prev-value=\"couldGoPrev()\"\r\n     have-next-value=\"couldGoNext()\"\r\n     select-prev-value=\"goBack()\"\r\n     select-next-value=\"goForward()\"></div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/platform/widgets/inputs/stepper/stepper-select.html
// module id = 401
// module chunks = 0